var path = 'app/components/common/forms/templates/ui-select-async.html';
var html = "<ui-select data-ng-model=\"model[options.key]\" data-required=\"{{to.required}}\" data-disabled=\"{{to.disabled}}\" theme=\"bootstrap\"><ui-select-match placeholder=\"{{to.placeholder}}\" data-allow-clear=\"{{to.allowClear}}\">{{$select.selected[to.labelProp]}}</ui-select-match><ui-select-choices data-repeat=\"{{to.ngOptions}}\" data-refresh=\"{{to.refresh}}\" data-refresh-delay=\"{{to.refreshDelay}}\"><div ng-bind-html=\"option[to.labelProp] | highlight: $select.search\"></div></ui-select-choices></ui-select>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/forms/templates/ui-select-async.html
// module id = 196
// module chunks = 0